import { Comment, ThumbUp, Reply, Facebook, Newspaper } from "@mui/icons-material";
import { Box, Divider } from "@mui/material";
import React from "react";
import { parseURL, prettyTruncate } from "../../../common";
import PostDateElement from "../element/PostDateElement";
import PostImageElement from "../element/PostImageElement";
import PostMetaElement from "../element/PostMetaElement";
import PostTextElement from "../element/PostTextElement";
import PostTitleElement from "../element/PostTitleElement";

function NewsPostCard({post, padding, intent}){
    
    let text = post.post_text;
    text = parseURL(text);
    
    const title = post.title || post.user_screenname;
    const siteName = post.site;

    return <>
        <Box p={padding}>
            <PostTitleElement title={siteName} post={post} link={'http://' + siteName} />
        </Box>

        <PostImageElement post={post}/>
        
        <Box p={padding}>
            <PostTitleElement title={title} post={post} />
            
            <PostTextElement text={prettyTruncate(text,300)} post={post} intent={intent} />

            <PostDateElement post={post} />
        </Box>
        <Divider />
        <Box p={padding} display="flex" alignItems={"center"} justifyContent="space-between">
            <Box display="flex" alignItems={"center"} mr={1}>

                <ThumbUp sx={{marginRight: 0.25, marginLeft: 0.75}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_likes}</span>
                <Comment sx={{marginRight: 0.25, marginLeft: 0.75}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_comments}</span>
                <Reply sx={{marginRight: 0.25, marginLeft: 0.75}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_shares}</span>

            </Box>
            <Newspaper sx={{color: '#17c457'}}/>

        </Box>
        <Divider />
        <Box p={padding}>
            <PostMetaElement post={post} intent={intent} />
        </Box>
    </>
}
export default NewsPostCard;